<script setup lang="ts">
import CommonButton from "@/components/common/CommonButton.vue";
import {Plus} from "utruckin-icons";

interface IFilter {
  store: any
}

const props = withDefaults(defineProps<IFilter>(), {});

const emit = defineEmits<{
  (e: 'clickedAdd'): void
}>()

const clicked = () => {
  emit('clickedAdd')
}
</script>


<template>
  <div class="f-ui-filter">
    <div class="filter">
      <CommonButton prepend :prepend-icon="Plus" type="primary" label="Add Account" @click="clicked"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.f-ui-filter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 16px;

  .filter {
    display: flex;
    gap: 8px;
  }
}
</style>